import type { CronJobStatus, HubspotSyncResult } from '@brickup/shared/dto'
import { cronJobApi, cronJobRoutes } from './cron-job'

export type { HubspotSyncResult } from '@brickup/shared/dto'

const job = cronJobApi<CronJobStatus, HubspotSyncResult>(
  'hubspot-sync',
  cronJobRoutes('/hubspot-sync'),
)

export const useHubspotSyncConfig = job.useStatus
export const useHubspotSyncMutations = job.useMutations
